import { CrowdIcon } from './CrowdIcon';

/**
 * author: Google
 * id FEE6305B-081C-429E-9584-5A5C6D8FD38F
 * name crowd
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crowd.svg
 * tags
 * - Account / User 
 * - People / Family 
 */
export const CrowdSourceIcon = CrowdIcon;
export default CrowdSourceIcon